import styles from "./divider.module.scss";

export const Divider: React.FC = ({ children }) => {
  return <div className={styles.divider}>{children}</div>;
};
